export const mainNav = [
  { label: 'Products', to: '/#products' },
  { label: 'About', to: '/#about' },
  { label: 'Contact', to: '/#contact' },
  { label: 'Policies', to: '/policies' },
];

export const legalNav = [
  { label: 'Privacy Policy', to: '/policies#privacy' },
  { label: 'Terms of Service', to: '/policies#terms' },
  { label: 'Digital Delivery Policy', to: '/policies#delivery' },
  { label: 'Refund Policy', to: '/policies#refund' },
];
